import { withDependencies, named } from '@wix/thunderbolt-ioc'
import {
	PageFeatureConfigSymbol,
	IPageWillMountHandler,
	CompEventsRegistrarSym,
	ICompEventsRegistrar,
	Props,
	IPropsStore,
	BrowserWindowSymbol,
	BrowserWindow,
	ExperimentsSymbol,
	Experiments,
} from '@wix/thunderbolt-symbols'
import type { ContainerSliderPageConfig } from './types'
import { name } from './symbols'
import { scrollInnerContent, scrollInnerContentV2 } from './utils'

const containerSliderFactory = (
	compEventsRegistrar: ICompEventsRegistrar,
	propsStore: IPropsStore,
	window: BrowserWindow,
	pageFeatureConfig: ContainerSliderPageConfig,
	experiments: Experiments
): IPageWillMountHandler => {
	return {
		name: 'containerSlider',
		pageWillMount() {
			const shouldFixEdgeScrollCases = Boolean(experiments['specs.thunderbolt.slider_container_edges_fix'])
			if (shouldFixEdgeScrollCases) {
				pageFeatureConfig.scrollActions.forEach((actionBehavior) => {
					const buttonId = actionBehavior.triggerCompId
					const containerId = actionBehavior.targetContainerId
					const scrollDirection = actionBehavior.direction
					const containerProps = propsStore.get(containerId)

					const onButtonClick = () => {
						scrollInnerContentV2(containerProps, containerId, scrollDirection)
					}

					compEventsRegistrar.register(buttonId, 'onClick', onButtonClick)
				})
			} else {
				pageFeatureConfig.scrollForward.forEach((actionBehavior) => {
					const forwardButtonId = actionBehavior.triggerCompId
					const containerId = actionBehavior.targetContainerId
					const containerProps = propsStore.get(containerId)

					const onForwardButtonClick = () => {
						scrollInnerContent(containerProps, containerId, 'forward')
					}

					compEventsRegistrar.register(forwardButtonId, 'onClick', onForwardButtonClick)
				})

				pageFeatureConfig.scrollBackward.forEach((actionBehavior) => {
					const backwardButtonId = actionBehavior.triggerCompId
					const containerId = actionBehavior.targetContainerId
					const containerProps = propsStore.get(containerId)

					const onBackwardButtonClick = () => {
						scrollInnerContent(containerProps, containerId, 'backward')
					}

					compEventsRegistrar.register(backwardButtonId, 'onClick', onBackwardButtonClick)
				})
			}
		},
	}
}

export const ContainerSlider = withDependencies(
	[CompEventsRegistrarSym, Props, BrowserWindowSymbol, named(PageFeatureConfigSymbol, name), ExperimentsSymbol],
	containerSliderFactory
)
